//region :: Imports ::
import {MColor} from './Utils';

//endregion

/** */
export type MIcon = { name: string, color: MColor };

/** */
export const NewIconName = 'pi pi-plus';
export const AddIconName = 'pi pi-plus';
export const OpenIconName = 'pi pi-folder-open';
export const SaveIconName = 'pi pi-save';
export const DeleteIconName = 'pi pi-trash';
export const RefreshIconName = 'pi pi-refresh';
export const CopyIconName = 'pi pi-copy';
export const CloseIconName = 'pi pi-times';
export const SearchIconName = 'pi pi-search';
export const NavigateToIconName = 'pi pi-arrow-circle-right';
export const LoginIconName = 'pi pi-sign-in';
export const LogoutIconName = 'pi pi-sign-out';
export const HomeIconName = 'pi pi-home';

export const SuccessIconName = 'pi pi-check-circle';
export const InfoIconName = 'pi pi-info-circle';
export const WarningIconName = 'pi pi-exclamation-circle';
export const ErrorIconName = 'pi pi-times-circle';

export const OkIconName = 'pi pi-check';
export const CancelIconName = 'pi pi-times';
export const YesIconName = 'pi pi-check';
export const NoIconName = 'pi pi-times';
export const AllowIconName = 'pi pi-check';
export const DenyIconName = 'pi pi-ban';

export const LightThemeIconName = 'pi pi-sun';
export const DarkThemeIconName = 'pi pi-moon';

/** */
export const SuccessIcon: MIcon = {name: SuccessIconName, color: 'mcolor-danger'};
export const InfoIcon: MIcon = {name: InfoIconName, color: 'mcolor-info'};
export const WarningIcon: MIcon = {name: WarningIconName, color: 'mcolor-warning'};
export const ErrorIcon: MIcon = {name: ErrorIconName, color: 'mcolor-danger'};
